import { useState } from "react";
import { ClassLinkLoginButton as EtClassLinkLoginButton } from "@ever-tutor/et-ui";
import { useNotificationStore } from "@/store/useNotificationStore";
import { authClient } from "@/lib/auth-client";
import { NotificationType } from "@/store/useNotificationStore";
import classLinkLogo from "@/assets/classlink-logo.png";

interface ClassLinkLoginButtonProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  mode?: "login" | "signup";
  label?: string;
}

const ClassLinkLoginButton = ({
  onSuccess,
  onError,
  mode = "login",
  label,
}: ClassLinkLoginButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotificationStore();

  const handleClassLinkLogin = async () => {
    try {
      setIsLoading(true);
      await authClient.signIn.oauth2({
        providerId: "classlink",
        callbackURL: window.location.origin,
      });
      onSuccess?.();
    } catch (error: any) {
      console.error("ClassLink login error:", error);
      const errorMessage = "ClassLink login failed";
      showNotification(errorMessage, NotificationType.WARNING);
      onError?.(errorMessage);
      setIsLoading(false);
    }
  };

  return (
    <EtClassLinkLoginButton
      onClick={handleClassLinkLogin}
      isLoading={isLoading}
      mode={mode}
      label={label}
      logoSrc={classLinkLogo}
      aria-label={
        label ??
        (mode === "signup"
          ? "Sign up with ClassLink"
          : "Sign in with ClassLink")
      }
    />
  );
};

export default ClassLinkLoginButton;
